import { FC } from 'react';
import { Mail, Phone } from 'lucide-react'; // Assuming you're using LucideIcons

type ContactUsCTAProps = {
  title: string;
  description: string;
  email: string;
  phone: string;
  office: string;
  showOffice: boolean; // New prop to conditionally show the office
  className?: string; // Optional prop to pass custom class names
};

const ContactUsCTA: FC<ContactUsCTAProps> = ({
  email,
  phone,
  office,
  title,
  description,
  showOffice,
  className = '', // Default to empty string if no className is provided
}) => {
  return (
    <div
      className={`grid items-center justify-between px-6 py-8 border rounded-3xl border-divider md:grid-cols-2 gap-y-8 ${className}`}
    >
      <div className="space-y-4 text-center md:text-left">
        <h2 className="font-semibold title-md">{title}</h2>
        <p className="max-w-2xl mx-auto text-sm text-foreground/70">{description}</p>
      </div>

      <div>
        <div className="flex flex-col items-center justify-end space-y-6 md:flex-row md:space-y-0 md:space-x-12">
          {/* Email Contact */}
          <div className="flex flex-col items-center space-y-3">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
              <Mail className="w-6 h-6 text-primary" />
            </div>
            <div className="text-center">
              <p className="mb-1 font-semibold">Email</p>
              <p className="text-sm text-foreground/70">{email}</p>
            </div>
          </div>

          {/* Phone Contact */}
          <div className="flex flex-col items-center space-y-3">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
              <Phone className="w-6 h-6 text-primary" />
            </div>
            <div className="text-center">
              <p className="mb-1 font-semibold">Phone</p>
              <p className="text-sm text-foreground/70">{phone}</p>
            </div>
          </div>

          {/* Office Contact - Display based on `showOffice` prop */}
          {showOffice && (
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <div className="text-center">
                <p className="mb-1 font-semibold">Office</p>
                <p className="text-sm text-foreground/70">{office}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUsCTA;
